module.exports = __webpack_public_path__ + "img/8-estatus-pendiente.e03d8120.svg";